<script setup>
import useGrid from "@/composables/useGrid";
import marketsService from "@/services/markets.service";
import {ref, onMounted, watch} from "vue";

const {gridParams, gridMethods, items} = useGrid(getIndexList, 5);
const {forUser} = defineProps(['forUser'])
const emit = defineEmits(['viewReport']);

const reports = ref([]);

watch(items, (newItems) => {
    reports.value = [...reports.value, ...newItems];
});

onMounted(() => {
    gridMethods.resetList();
});

function getIndexList(pageParams) {
    return marketsService.getReports(forUser ? 'me' : 'company', pageParams);
}

function loadMore() {
    gridMethods.changePage(gridParams.currentPage + 1);
}

function reportOpened(subsectorName) {
    if (!reports.value.some(item => item.subsector_name === subsectorName)) {
        reports.value = [];
        gridMethods.resetList();
    }
}

defineExpose({
    reportOpened,
});
</script>

<template>
    <div>
        <template v-if="!reports.length">
            <div v-if="forUser" class="report-placeholder">
                Market intelligence reports you generate will display here
            </div>

            <div v-else class="report-placeholder report-placeholder__team">
                Reports generated by your team will display here
            </div>
        </template>

        <div v-else>
            <div v-for="report in reports" :key="report.subsector_id" class="report-item report-item--landscape">
                <div class="report-item__inner">
                    <a class="link" @click="emit('viewReport', report.subsector_name)">{{report.subsector_name}} Partnership Landscape</a>
                    <br>
                    Created {{report.time}} <template v-if="!forUser">by {{report.user_name}}</template>
                </div>
            </div>

            <div v-if="gridParams.pagesCount > gridParams.currentPage" class="text-center mt-5">
                <a class="link" @click="loadMore">Show more</a>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
